import React from "react";
import ToolbarItem from "../ToolbarItem";
import { useEditorContext } from "../../Wysiwyg";

const HeadingsToolbarGroup = ({ headings = [1, 2, 3, 4, 5, 6] }) => {
  const { editor } = useEditorContext();
  
  return (
    <>
      {headings.map((level) => (
        <ToolbarItem
          id={`h${level}-toolbar-item`}
          key={level}
          tooltip={`Fejléc #${level}`}
          active={editor.isActive("heading", { level })}
          onToggle={() => editor.chain().focus().toggleHeading({ level }).run()}
          hotkey={`Ctrl + Alt + ${level}`}
          icon={
            <span style={{ fontWeight: "600", fontFamily: "times new roman" }}>
              H{level}
            </span>
          }
        />
      ))}
    </>
  );
};

export default HeadingsToolbarGroup;
